<template>
  <div class="areaCodeBox">
    <div class="tip">选择国家和地区</div>
    <div class="main">
      <div class="allList">
        <div
          class="list"
          v-for="(item, index) in sequenceBox"
          :key="index"
          :id="item"
          v-if="
            areaList[item == '#' ? 'HOT' : item] &&
            areaList[item == '#' ? 'HOT' : item].length > 0
          "
        >
          <p class="title" v-if="item!='#'">{{ item == "#" ? "热门" : item }}</p>
          <ul>
            <li
              v-for="(item1, index1) in areaList[item == '#' ? 'HOT' : item]"
              :key="index1"
              @click="chouseType(item1)"
            >
              <span>{{ item1.country }}</span>
              <span class="code">{{ item1.countryode }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="sequence">
        <ul>
          <li
            v-for="(item, index) in sequenceBox"
            v-if="
              areaList[item == '#' ? 'HOT' : item] &&
              areaList[item == '#' ? 'HOT' : item].length > 0
            "
            :key="index"
            @click="goto(item)"
            :class="{ active: sequence == item }"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "areaCode",
  metaInfo() {
    return {
      title: "选择国家和地区",
    };
  },
  data() {
    return {
      noHeader: 0,
      areaList: [],
      sequenceBox: [],
      sequence: "",
    };
  },
  components: {},
  mounted() {
    this.noHeader = localStorage.getItem("noHeader");
    this.getCode();
    this.getSequence();
  },
  methods: {
    getSequence() {
      this.sequenceBox.push("#");
      for (var i = 0; i < 26; i++) {
        this.sequenceBox.push(String.fromCharCode(65 + i)); //输出A-Z  26个大写字母
      }
    },
    getCode() {
      this.$post("iart-api-cmn/api/cmn/data/queryByCountry", {}).then((res) => {
        if (res.code == 1) {
          this.areaList = res.data;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    chouseType(item) {
      sessionStorage.setItem("areaCode", JSON.stringify(item));
      this.$router.back();
    },
    goto(id) {
      if (id == "#") {
        document.getElementById("#").scrollIntoView();
        this.sequence = id;
      }
      if (document.getElementById(id)) {
        this.sequence = id;
        document.getElementById(id).scrollIntoView();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.areaCodeBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  .tip {
    font-size: 22px;
    line-height: 34px;
    color: rgba(53, 54, 60, 1);
    font-weight: bolder;
    padding: 16px;
  }
  .main {
    border-top: 0.5px solid rgba(230, 230, 230, 1);
    flex: 1;
    overflow: auto;
    padding: 0 10px 0 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .allList {
      height: 100%;
      overflow: auto;
      flex: 1;
      .list {
          margin-top: 8px;
        .title {
          font-size: 16px;
          line-height: 22px;
          color: rgba(53, 54, 60, 1);
          font-weight: 600;
        }
        ul {
          margin-top: 8px;
          li {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 16px 0;
            border-bottom: 0.5px solid rgba(237, 237, 237, 1);
            span {
              font-size: 14px;
              line-height: 20px;
              color: rgba(53, 54, 60, 1);
            }
            .code {
              color: rgba(134, 135, 138, 1);
            }
          }
        }
      }
    }
    .sequence {
      margin-left: 10px;
      li {
        font-size: 12px;
        line-height: 17px;
        color: rgba(174, 175, 177, 1);
      }
      li.active {
        // color: rgba(246, 38, 37, 1);
      }
    }
  }
}
</style>